const SPACES_FILTER_KEY = "spaces_filter";

interface FilterWithKey {
  key: string;
  value?: unknown;
}

const isFilterWithKey = (value: unknown): value is FilterWithKey =>
  typeof value === "object" && value !== null && "key" in value;

const compactFilterEntry = (filter: unknown): unknown => {
  if (!isFilterWithKey(filter) || filter.key !== SPACES_FILTER_KEY) {
    return filter;
  }

  return {
    ...filter,
    value: Array.isArray(filter.value) ? filter.value.join(",") : filter.value,
  };
};

export const compactAnalyticsFilters = (
  filters: object,
): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(filters).map(([key, filter]) => [
      key,
      compactFilterEntry(filter),
    ]),
  );

export const expandAnalyticsFilters = <T extends FilterWithKey>(filters: T[]) =>
  filters.map(filter =>
    filter.key === SPACES_FILTER_KEY && typeof filter.value === "string"
      ? { ...filter, value: filter.value.split(",") }
      : filter,
  );

export const compactAnalyticsParams = (params: { filters?: object }) => {
  if (!params.filters) {
    return params;
  }
  return { ...params, filters: compactAnalyticsFilters(params.filters) };
};
